(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.shoppable-video').forEach((section) => {
      const payloadNode = section.querySelector('[data-carousel-payload]');
      if (!payloadNode) return;
      let slides = [];
      try {
        slides = JSON.parse(payloadNode.textContent.trim());
      } catch (e) {
        return;
      }
      if (!slides.length) return;

      const track = section.querySelector('[data-carousel-track]');
      const items = Array.from(section.querySelectorAll('[data-carousel-item]'));
      const sliderVideos = Array.from(section.querySelectorAll('.sv-video'));
      const carouselPrev = Array.from(section.querySelectorAll('.sv-nav--bottom .slideshow-control--previous'));
      const carouselNext = Array.from(section.querySelectorAll('.sv-nav--bottom .slideshow-control--next'));
      const bottomNav = section.querySelector('[data-sv-bottom-nav]');

      const modal = section.querySelector('[data-modal]');
      const modalVideo = modal.querySelector('[data-modal-video]');
      const progress = modal.querySelector('[data-progress]');
      const indexIndicator = modal.querySelector('[data-index-indicator]');
      const playPause = modal.querySelector('[data-play-pause]');
      const muteToggle = modal.querySelector('[data-mute-toggle]');
      const videoToggle = modal.querySelector('[data-video-toggle]');
      const modalPrev = modal.querySelector('[data-modal-prev]');
      const modalNext = modal.querySelector('[data-modal-next]');
      const mobileDrawer = modal.querySelector('[data-mobile-drawer]');
      const desktopPicker = modal.querySelector('[data-variant-picker]');
      const mobilePicker = modal.querySelector('[data-variant-picker-mobile]');
      const atcDesktop = modal.querySelector('[data-add-to-cart]');
      const atcMobile = modal.querySelector('[data-add-to-cart-mobile]');
      const atcDefaultLabel = atcDesktop?.textContent?.trim() || 'Add to cart';
      const addingLabel = section.dataset.addingLabel || 'Adding…';
      const addedLabel = section.dataset.addedLabel || 'Added';

      let currentIndex = 0;
      let selectedVariantId = null;
      let atcBusy = false;
      let addedTimer = null;
      let statusTimer = null;

      const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
      const carouselMode = () => section.dataset.carouselPlay;
      const modalMode = () => section.dataset.modalPlay;
      const loopOn = () => section.dataset.loop === 'true';
      const renderImg = (url) => (url ? `<img src="${url}" alt="" loading="lazy">` : '');

      const ICON_PLAY =
        '<svg viewBox="0 0 448 512" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M424 256L24 8v496z"/></svg>';
      const ICON_PAUSE =
        '<svg viewBox="0 0 320 512" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M48 64h64v384H48zM208 64h64v384h-64z"/></svg>';
      const ICON_MUTE =
        '<svg viewBox="0 0 640 512" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M301 35a24 24 0 0119 29v384a24 24 0 01-41 17L131 352H64a64 64 0 01-64-64v-64a64 64 0 0164-64h67L278 40a24 24 0 0123-5zM633 175l-46 46 46 46a24 24 0 01-34 34l-46-46-46 46a24 24 0 01-34-34l46-46-46-46a24 24 0 0134-34l46 46 46-46a24 24 0 0134 34z"/></svg>';
      const ICON_UNMUTE =
        '<svg viewBox="0 0 480 512" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M301 35a24 24 0 0119 29v384a24 24 0 01-41 17L131 352H64a64 64 0 01-64-64v-64a64 64 0 0164-64h67L278 40a24 24 0 0123-5z"/></svg>';

      /* ── Carousel playback ── */
      let observer = null;
      const hoverH = [];
      const clickH = [];

      const setPaused = (video, paused) => {
        const item = video.closest('[data-carousel-item]');
        if (item) item.setAttribute('data-paused', paused ? 'true' : 'false');
      };
      const pauseAll = (except) =>
        sliderVideos.forEach((v) => {
          if (v !== except) {
            v.pause();
            setPaused(v, true);
          }
        });

      const clearPlayback = () => {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        hoverH.forEach(({ v, enter, leave }) => {
          v.removeEventListener('mouseenter', enter);
          v.removeEventListener('mouseleave', leave);
        });
        hoverH.length = 0;
        clickH.forEach(({ v, click }) => v.removeEventListener('click', click));
        clickH.length = 0;
      };

      const setupPlayback = () => {
        clearPlayback();
        sliderVideos.forEach((v) => {
          v.loop = loopOn();
          v.muted = true;
          v.playsInline = true;
          v.pause();
          setPaused(v, true);
        });
        const mode = carouselMode();

        if (mode === 'autoplay_in_viewport') {
          observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                const v = e.target;
                if (e.isIntersecting && e.intersectionRatio >= 0.9) {
                  v.play()
                    .then(() => setPaused(v, false))
                    .catch(() => setPaused(v, true));
                } else {
                  v.pause();
                  setPaused(v, true);
                }
              });
            },
            { root: track, threshold: [0, 0.9, 1] }
          );
          sliderVideos.forEach((v) => observer.observe(v));
        } else if (mode === 'play_on_hover') {
          sliderVideos.forEach((v) => {
            const enter = () =>
              v
                .play()
                .then(() => setPaused(v, false))
                .catch(() => {});
            const leave = () => {
              v.pause();
              setPaused(v, true);
            };
            v.addEventListener('mouseenter', enter);
            v.addEventListener('mouseleave', leave);
            hoverH.push({ v, enter, leave });
          });
        } else if (mode === 'click_to_play') {
          sliderVideos.forEach((v) => {
            const click = (ev) => {
              ev.stopPropagation();
              if (v.paused) {
                pauseAll(v);
                v.play()
                  .then(() => setPaused(v, false))
                  .catch(() => {});
              } else {
                v.pause();
                setPaused(v, true);
              }
            };
            v.addEventListener('click', click);
            clickH.push({ v, click });
          });
        }
      };

      /* ── Product / variant UI ── */
      const priceTargets = () =>
        ['[data-strip-price]', '[data-drawer-price]', '[data-drawer-price-mobile]'].map((s) => modal.querySelector(s));
      const compareTargets = () =>
        ['[data-strip-compare]', '[data-drawer-compare]', '[data-drawer-compare-mobile]'].map((s) =>
          modal.querySelector(s)
        );

      const setPrices = (price, compare) => {
        priceTargets().forEach((n) => {
          if (n) n.innerHTML = price || '';
        });
        compareTargets().forEach((n) => {
          if (n) n.innerHTML = compare || '';
        });
      };

      const setProduct = (product) => {
        ['[data-strip-title]', '[data-drawer-title]', '[data-drawer-title-mobile]'].forEach((s) => {
          const n = modal.querySelector(s);
          if (n) n.textContent = product?.title || '';
        });
        ['[data-strip-image]', '[data-drawer-image]', '[data-drawer-image-mobile]'].forEach((s) => {
          const n = modal.querySelector(s);
          if (n) n.innerHTML = renderImg(product?.image);
        });
        ['[data-drawer-description]', '[data-drawer-description-mobile]'].forEach((s) => {
          const n = modal.querySelector(s);
          if (n) n.innerHTML = product?.description || '';
        });
        modal.querySelectorAll('[data-drawer-link], [data-drawer-link-mobile]').forEach((n) => {
          n.href = product?.url || '#';
        });
        setPrices(product?.price, product?.compareAtPrice);
      };

      const setStatus = (msg, mobile) => {
        const n = modal.querySelector(mobile ? '[data-status-mobile]' : '[data-status]');
        if (n) n.textContent = msg || '';
        if (statusTimer) clearTimeout(statusTimer);
        if (msg)
          statusTimer = setTimeout(() => {
            modal.querySelectorAll('[data-status], [data-status-mobile]').forEach((el) => {
              el.textContent = '';
            });
          }, 4000);
      };

      const syncAtc = () => {
        let label = atcDefaultLabel;
        if (atcBusy) label = addingLabel;
        [atcDesktop, atcMobile].forEach((b) => {
          if (!b) return;
          b.textContent = label;
          b.disabled = atcBusy || !selectedVariantId;
        });
      };

      const renderVariants = (product) => {
        const optionNames = product?.optionNames || [];
        const variants = product?.variants || [];
        if (desktopPicker) desktopPicker.innerHTML = '';
        if (mobilePicker) mobilePicker.innerHTML = '';

        if (!variants.length) {
          selectedVariantId = null;
          syncAtc();
          return;
        }
        const firstAvailable = () => variants.find((v) => v.available) || variants[0];

        if (!optionNames.length) {
          const v = firstAvailable();
          selectedVariantId = v?.id || null;
          setPrices(v?.price || product?.price, v?.compareAtPrice ?? null);
          syncAtc();
          return;
        }

        let selected = firstAvailable();
        let selectedOptions = Array.isArray(selected?.options) ? [...selected.options] : [];

        const match = (opts) => variants.find((v) => optionNames.every((_, i) => v.options?.[i] === opts[i]));
        const valueAvailable = (idx, val) =>
          variants.some(
            (v) =>
              v.available &&
              v.options?.[idx] === val &&
              optionNames.every((_, i) => i === idx || v.options?.[i] === selectedOptions[i])
          );

        const renderPicker = (container) => {
          if (!container) return;
          container.innerHTML = '';
          optionNames.forEach((name, idx) => {
            const group = document.createElement('div');
            group.className = 'sv-variant-group';
            const label = document.createElement('p');
            label.className = 'sv-variant-group-label';
            label.textContent = name;
            group.appendChild(label);
            const wrap = document.createElement('div');
            wrap.className = 'sv-variant-values';
            [...new Set(variants.map((v) => v.options?.[idx]).filter(Boolean))].forEach((val) => {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'sv-variant';
              btn.textContent = val;
              btn.classList.toggle('is-active', selectedOptions[idx] === val);
              btn.disabled = !valueAvailable(idx, val);
              btn.addEventListener('click', () => {
                selectedOptions[idx] = val;
                const exact = match(selectedOptions);
                if (exact) selected = exact;
                selectedVariantId = selected?.id || null;
                selectedOptions = Array.isArray(selected?.options) ? [...selected.options] : selectedOptions;
                setPrices(selected?.price, selected?.compareAtPrice);
                renderPicker(desktopPicker);
                renderPicker(mobilePicker);
                syncAtc();
              });
              wrap.appendChild(btn);
            });
            group.appendChild(wrap);
            container.appendChild(group);
          });
        };

        selectedVariantId = selected?.id || null;
        setPrices(selected?.price, selected?.compareAtPrice);
        renderPicker(desktopPicker);
        renderPicker(mobilePicker);
        syncAtc();
      };

      /* ── Modal controls ── */
      const syncButtons = () => {
        playPause.innerHTML = modalVideo.paused ? ICON_PLAY : ICON_PAUSE;
        muteToggle.innerHTML = modalVideo.muted ? ICON_UNMUTE : ICON_MUTE;
      };
      const updateProgress = () => {
        progress.value = modalVideo.duration ? String((modalVideo.currentTime / modalVideo.duration) * 100) : 0;
      };
      const updateModalNav = () => {
        const single = slides.length <= 1;
        if (modalPrev) modalPrev.disabled = single;
        if (modalNext) modalNext.disabled = single;
      };
      const updateCarouselNav = () => {
        if (!track) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const needsNav = max > 2 || items.length > 1;
        if (bottomNav) bottomNav.hidden = !needsNav;
        /* Infinite carousel — never disable arrows when there is more than one item */
        carouselPrev.forEach((b) => {
          b.disabled = items.length <= 1;
        });
        carouselNext.forEach((b) => {
          b.disabled = items.length <= 1;
        });
      };

      const updateCenterFocus = () => {
        if (!track || !items.length) return;
        const trackRect = track.getBoundingClientRect();
        const centerX = trackRect.left + trackRect.width / 2;
        let best = null;
        let bestDist = Infinity;
        items.forEach((item) => {
          const r = item.getBoundingClientRect();
          if (r.right < trackRect.left || r.left > trackRect.right) return;
          const dist = Math.abs(r.left + r.width / 2 - centerX);
          if (dist < bestDist) {
            bestDist = dist;
            best = item;
          }
        });
        items.forEach((item) => item.classList.toggle('is-center', item === best));
      };

      const itemScrollAmount = () => {
        const item = track && track.querySelector('.sv-item');
        if (!item) return track ? track.clientWidth * 0.9 : 0;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return item.getBoundingClientRect().width + gap;
      };

      /* Scroll so an item’s center aligns with the track’s center (center mode). */
      const scrollItemToCenter = (item, behavior = 'auto') => {
        if (!track || !item) return;
        const trackRect = track.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const delta = itemRect.left + itemRect.width / 2 - (trackRect.left + trackRect.width / 2);
        if (Math.abs(delta) < 1) return;
        track.scrollBy({ left: delta, behavior });
      };

      /*
        Mobile: start on the 2nd card so peeks show on both sides (like desktop).
        Desktop already gets that from multiple visible items at scrollLeft 0.
      */
      const applyInitialCenterMode = () => {
        if (!track || items.length < 2 || isDesktop()) return;
        scrollItemToCenter(items[1], 'auto');
        updateCenterFocus();
      };

      const scrollByItem = (dir) => {
        if (!track || items.length <= 1) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const amount = itemScrollAmount();
        const atStart = track.scrollLeft <= 1;
        const atEnd = track.scrollLeft >= max - 1;

        if (dir > 0 && atEnd) {
          /* Loop to start — on mobile land on 2nd card again for center peeks */
          if (!isDesktop() && items.length >= 2) {
            scrollItemToCenter(items[1], 'smooth');
          } else {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          }
          return;
        }
        if (dir < 0 && atStart) {
          track.scrollTo({ left: max, behavior: 'smooth' });
          return;
        }
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };

      const setSlide = (index, autoplay = true) => {
        if (!slides[index]) return;
        currentIndex = index;
        const slide = slides[index];
        indexIndicator.textContent = `${index + 1}/${slides.length}`;
        modalVideo.src = slide.videoUrl || '';
        modalVideo.poster = slide.poster || '';
        modalVideo.currentTime = 0;
        modalVideo.muted = true;
        modalVideo.loop = loopOn();
        progress.value = 0;
        atcBusy = false;
        if (addedTimer) clearTimeout(addedTimer);
        setStatus('');
        setProduct(slide.product);
        renderVariants(slide.product);
        syncButtons();
        updateModalNav();
        if (autoplay && slide.videoUrl && modalMode() === 'autoplay') modalVideo.play().catch(() => {});
      };

      let prevBodyOverflow = '';
      const openModal = (index) => {
        setSlide(index);
        if (!modal.open) {
          prevBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          modal.showModal();
        }
        if (modalMode() === 'play_on_hover') modalVideo.pause();
      };
      const closeModal = () => {
        atcBusy = false;
        if (addedTimer) clearTimeout(addedTimer);
        modalVideo.pause();
        if (mobileDrawer) mobileDrawer.classList.remove('is-open');
        document.body.style.overflow = prevBodyOverflow;
        modal.close();
        syncAtc();
        setStatus('');
      };
      const goPrev = () => {
        if (!slides.length) return;
        setSlide(currentIndex <= 0 ? slides.length - 1 : currentIndex - 1);
      };
      const goNext = () => {
        if (!slides.length) return;
        setSlide(currentIndex >= slides.length - 1 ? 0 : currentIndex + 1);
      };

      /* ── Wiring ── */
      items.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          if (carouselMode() === 'click_to_play' && e.target.closest('.sv-video')) return;
          openModal(index);
        });
      });

      setupPlayback();
      updateCarouselNav();
      updateCenterFocus();
      /* After layout: mobile starts on 2nd item so left + right peeks are visible */
      requestAnimationFrame(() => {
        applyInitialCenterMode();
        requestAnimationFrame(applyInitialCenterMode);
      });
      track?.addEventListener(
        'scroll',
        () => {
          updateCarouselNav();
          updateCenterFocus();
        },
        { passive: true }
      );
      window.addEventListener('resize', () => {
        updateCarouselNav();
        updateCenterFocus();
        setupPlayback();
      });

      carouselPrev.forEach((b) =>
        b.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          scrollByItem(-1);
        })
      );
      carouselNext.forEach((b) =>
        b.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          scrollByItem(1);
        })
      );

      modal.querySelector('[data-modal-close]').addEventListener('click', closeModal);
      modalPrev?.addEventListener('click', goPrev);
      modalNext?.addEventListener('click', goNext);
      const toggleVideo = () => {
        if (modalVideo.paused) modalVideo.play();
        else modalVideo.pause();
      };
      videoToggle?.addEventListener('click', toggleVideo);
      playPause.addEventListener('click', toggleVideo);
      muteToggle.addEventListener('click', () => {
        modalVideo.muted = !modalVideo.muted;
        syncButtons();
      });
      videoToggle?.addEventListener('mouseenter', () => {
        if (modalMode() === 'play_on_hover') modalVideo.play().catch(() => {});
      });
      videoToggle?.addEventListener('mouseleave', () => {
        if (modalMode() === 'play_on_hover') modalVideo.pause();
      });
      progress.addEventListener('input', () => {
        if (modalVideo.duration) modalVideo.currentTime = modalVideo.duration * (Number(progress.value) / 100);
      });
      modalVideo.addEventListener('timeupdate', updateProgress);
      modalVideo.addEventListener('play', syncButtons);
      modalVideo.addEventListener('pause', syncButtons);
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });

      modal.querySelectorAll('[data-open-drawer]').forEach((b) =>
        b.addEventListener('click', () => {
          if (!isDesktop()) mobileDrawer?.classList.add('is-open');
        })
      );
      const mobileBottom = modal.querySelector('[data-mobile-bottom]');
      mobileBottom?.addEventListener('click', (e) => {
        if (!isDesktop() && !e.target.closest('a[href]')) mobileDrawer?.classList.add('is-open');
      });
      modal
        .querySelector('[data-close-drawer]')
        ?.addEventListener('click', () => mobileDrawer.classList.remove('is-open'));
      mobileDrawer?.addEventListener('click', (e) => {
        if (e.target === mobileDrawer) mobileDrawer.classList.remove('is-open');
      });

      /* ── Add to cart ──
         POSTs to /cart/add.js, then broadcasts standard cart events and updates
         common cart-count selectors. If your Horizon cart drawer needs an explicit
         open/refresh, wire it in publishCartUpdate() below. */
      const publishCartUpdate = async () => {
        let cart = null;
        try {
          const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (r.ok) cart = await r.json();
        } catch (_) {}
        ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach((name) =>
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart, source: 'shoppable-video' } }))
        );
        if (cart) {
          document.querySelectorAll('.js-cart-count, [data-cart-count], .cart-count, cart-count').forEach((el) => {
            el.textContent = String(cart.item_count);
          });
        }
        return cart;
      };

      const addToCart = async (mobile) => {
        if (!selectedVariantId) {
          setStatus('Select an option', mobile);
          return;
        }
        atcBusy = true;
        syncAtc();
        setStatus('');
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(selectedVariantId), quantity: 1 }] }),
          });
          if (!res.ok) throw new Error('add failed');
          await publishCartUpdate();
          atcBusy = false;
          syncAtc();
          [atcDesktop, atcMobile].forEach((b) => {
            if (b) b.textContent = addedLabel;
          });
          if (addedTimer) clearTimeout(addedTimer);
          addedTimer = setTimeout(syncAtc, 2500);
        } catch (e) {
          atcBusy = false;
          syncAtc();
          setStatus('Could not add to cart', mobile);
        }
      };
      atcDesktop?.addEventListener('click', () => addToCart(false));
      atcMobile?.addEventListener('click', () => addToCart(true));
      syncAtc();

      document.addEventListener('keydown', (e) => {
        if (!modal.open) return;
        if (e.key === 'ArrowLeft') goPrev();
        if (e.key === 'ArrowRight') goNext();
        if (e.key === 'Escape') closeModal();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
